import React from 'react';

export const FilterLines: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.6667 4.5333H13.3333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.8 8H11.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.4 11.4667H9.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
